import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "../../useAppTheme";

type Props = {
	size?: number;
	color?: string;
};

const PremiumIcon = ({ size = 24, color }: Props) => {
	const theme = useAppTheme();

	return (
		<Icon
			name="crown-outline"
			size={18}
			color={color ?? theme.colors.primary}
		/>
	);
};

export default PremiumIcon;
